import axios from 'axios';
import { openAPIErrorCallback } from '../callbacks';
import { V1_MARKETPLACES } from './constants';

export function getMarketplaces(res?) {
  return axios
    .get(V1_MARKETPLACES, { params: res.params, withCredentials: true })
    .catch(openAPIErrorCallback);
}

export function getAppDetail({ id }) {
  return axios
    .get(`${V1_MARKETPLACES}/${id}`, { withCredentials: true })
    .catch(openAPIErrorCallback);
}
